import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { epsResponse } from "src/app/interfaces/response/epsResponse.interface";
import { SharedServices } from "../../shared.service";
import { DialogModulsComponent } from "../dialog-moduls/dialog-moduls.component";




@Component({
    selector: 'app-dialog-register',
    templateUrl: './dialog-register.component.html',
    styleUrls: ['./dialog-register.component.scss']
})

export class DialogRegisterComponent implements OnInit {
    form!: FormGroup;
    listRol = [
        {
            name: "Distribuidor",
        },
        {
            name: "EPS"
        }
    ]

    lisAdmin = [
        {
            id: 1,
            name: "Si"
        },
        {
            id: 0,
            name: "No"
        }
    ]

    listRoles = [
        {
            id: 1,
            name: "Rol 1"
        },
        {
            id: 2,
            name: "Rol 2"
        },
        {
            id: 3,
            name: "Rol 3"
        },
        {
            id: 4,
            name: "Rol 4"
        }
    ]

    listEps: epsResponse[] = []
    isLoading: boolean = false
    mostrarRolUsuario = false;



    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<DialogRegisterComponent>,
        public dialog: MatDialog,

        private fb: FormBuilder,
        private sharedServices: SharedServices

    ) {

    }

    ngOnInit(): void {
        this.isLoading = true
        const data: object = {
            "action": 'EPS',
        }
        this.sharedServices.postRegisterUser(data).subscribe({
            next: (res: epsResponse[]) => {
                this.isLoading = false;
                this.listEps = res
            },
            error: (err) => {

            }
        });

        this.form = this.fb.group({
            rol: ['', [Validators.required]],
            roles: ['', [Validators.required]],
            administrador: ['', [Validators.required]],
            numberId: ['', [Validators.required]],
            lastName: ['', [Validators.required,]],
            name: ['', [Validators.required,]],
            idEPS: ['',],
            idPartner: [{ value: this.sharedServices.infoCredential.partner, disabled: true }, [Validators.required,]],
            phoneNumber: ['', [Validators.required,]],
            email: ['', [Validators.required, Validators.email]],
        });
    }

    onRoleChange(value: string) {
        if (value === 'Distribuidor') {
            this.form.get('idEPS')?.setValue('');
        }
        this.mostrarRolUsuario = value === 'Distribuidor';

        if (!this.mostrarRolUsuario) {
            this.form.patchValue({ roles: null });
        }
    }



    sendData() {
        this.isLoading = true;
        const data = this.form.getRawValue()
        data.action = "REGISTER_TEMPORAL"
        this.sharedServices.postRegisterUser(data).subscribe({
            next: (res: any) => {
                this.isLoading = false;

            },
            error: (err) => {

            }
        });

    }

    close() {
        this.dialogRef.close();

    }

    openDialogModulos() {
        let displayedColumns = [
            { key: 'usuarios', label: 'Usuarios', disabled: false },
            { key: 'dashboard', label: 'Dashboard', disabled: false },
            { key: 'products', label: 'Productos', disabled: false },
            { key: 'mipres', label: 'Mipres', disabled: false },
            { key: 'usuarios', label: 'Usuarios', disabled: false },
            { key: 'dashboard', label: 'Dashboard', disabled: false },
            { key: 'products', label: 'Productos', disabled: false },
            { key: 'mipres', label: 'Mipres', disabled: false },
            { key: 'usuarios', label: 'Usuarios', disabled: false },
            { key: 'dashboard', label: 'Dashboard', disabled: false },
            { key: 'products', label: 'Productos', disabled: false },
            { key: 'mipres', label: 'Mipres', disabled: false },
        ]
        const dialogRef = this.dialog.open(DialogModulsComponent, {
            width: '575px',
            height: '600px',
            disableClose: false,
            data: displayedColumns,
        });

        dialogRef.afterClosed().subscribe((result) => {
        });
    }

}